import { SensorTypes } from '@/store/types/DataComparisonType'

export type WeatherReportField = {
  columnName: string
  displayName: string
  metricUnit: string
  imperialUnit: string
  chartAxisName: string
  chartType?: string
  isFixed?: number
}

export const WeatherReportFields: Record<string, WeatherReportField> = {
  WindSpeedHigh: {
    columnName: 'wind_speed_hi',
    displayName: 'weatherDashboard.windSpeedHigh',
    metricUnit: 'm/s',
    imperialUnit: 'mph',
    chartAxisName: 'Speed',
  },
  WindSpeedAverage: {
    columnName: 'wind_speed_avg',
    displayName: 'weatherDashboard.windSpeedAverage',
    metricUnit: 'm/s',
    imperialUnit: 'mph',
    chartAxisName: 'Speed',
  },
  RainFall: {
    columnName: 'rainfall_mm',
    displayName: 'weatherDashboard.rainFall',
    metricUnit: 'mm',
    imperialUnit: 'in',
    chartAxisName: 'Rain',
    chartType: 'barChart',
  },
  TemperatureOutdoor: {
    columnName: 'temp_out',
    displayName: 'weatherDashboard.temperatureOutdoor',
    metricUnit: 'C',
    imperialUnit: 'F',
    chartAxisName: 'Temperature',
  },
  TemperatureOutdoorHigh: {
    columnName: 'temp_out_hi',
    displayName: 'weatherDashboard.temperatureOutdoorHigh',
    metricUnit: 'C',
    imperialUnit: 'F',
    chartAxisName: 'Temperature',
  },
  TemperatureOutdoorLow: {
    columnName: 'temp_out_lo',
    displayName: 'weatherDashboard.temperatureOutdoorLow',
    metricUnit: 'C',
    imperialUnit: 'F',
    chartAxisName: 'Temperature',
  },
  HumidityOutdoor: {
    columnName: 'hum_out',
    displayName: 'weatherDashboard.humidityOutdoor',
    metricUnit: '%',
    imperialUnit: '%',
    chartAxisName: 'Humidity Out door',
  },
  HeatIndex: {
    columnName: 'heat_index_out',
    displayName: 'weatherDashboard.heatIndex',
    metricUnit: 'C',
    imperialUnit: 'F',
    chartAxisName: 'Heat Index',
  },
  WindChill: {
    columnName: 'wind_chill',
    displayName: 'weatherDashboard.windChill',
    metricUnit: 'C',
    imperialUnit: 'F',
    chartAxisName: 'Wind Chill',
  },
  DewPoint: {
    columnName: 'dew_point_out',
    displayName: 'weatherDashboard.dewPoint',
    metricUnit: 'C',
    imperialUnit: 'F',
    chartAxisName: 'Dew Point',
  },
  WetBulb: {
    columnName: 'wet_bulb',
    displayName: 'weatherDashboard.wetBulb',
    metricUnit: 'C',
    imperialUnit: 'F',
    chartAxisName: 'Wet Bulb',
  },
  THSWIndex: {
    columnName: 'thsw_index',
    displayName: 'weatherDashboard.thswIndex',
    metricUnit: '',
    imperialUnit: '',
    chartAxisName: 'THSWIndex',
  },
  THWIndex: {
    columnName: 'thw_index',
    displayName: 'weatherDashboard.thwIndex',
    metricUnit: '',
    imperialUnit: '',
    chartAxisName: 'THWIndex',
  },
  SolarRadiationAverage: {
    columnName: 'solar_rad_avg',
    displayName: 'weatherDashboard.solarRadiationAverage',
    metricUnit: 'W/m²',
    imperialUnit: '',
    chartAxisName: 'Solar Radiation',
  },
  SolarRadiationHigh: {
    columnName: 'solar_rad_hi',
    displayName: 'weatherDashboard.solarRadiationHigh',
    metricUnit: 'W/m²',
    imperialUnit: '',
    chartAxisName: 'Solar Radiation',
  },
  SolarEnergy: {
    columnName: 'solar_energy',
    displayName: 'weatherDashboard.solarEnergy',
    metricUnit: 'Wh/m²',
    imperialUnit: '',
    chartAxisName: 'Solar Energy',
  },

  RainRateHighMM: {
    columnName: 'rain_rate_hi_mm',
    displayName: 'weatherDashboard.rainRateHighMM',
    metricUnit: 'mm/h',
    imperialUnit: '',
    chartAxisName: 'Rain Rate',
  },
  RainRateHighIn: {
    columnName: 'rain_rate_hi_in',
    displayName: 'weatherDashboard.rainRateHighIn',
    metricUnit: '',
    imperialUnit: 'in/h',
    chartAxisName: 'Rain Rate',
  },
  RainRateHighClicks: {
    columnName: 'rain_rate_hi_clicks',
    displayName: 'weatherDashboard.rainRateHighClicks',
    metricUnit: '',
    imperialUnit: '',
    chartAxisName: 'Rain Rate High Clicks',
  },
  RainFallClicks: {
    columnName: 'rainfall_clicks',
    displayName: 'weatherDashboard.rainFallClicks',
    metricUnit: '',
    imperialUnit: '',
    chartAxisName: 'Rain Fall Clicks',
  },
  RainFallIn: {
    columnName: 'rainfall_in',
    displayName: 'weatherDashboard.rainFallIn',
    metricUnit: '',
    imperialUnit: 'in',
    chartAxisName: 'Rain',
    chartType: 'barChart',
    isFixed: 4,
  },

  WindDirectionPrevailing: {
    columnName: 'wind_dir_of_prevail',
    displayName: 'weatherDashboard.windDirectionPrevailing',
    metricUnit: '°',
    imperialUnit: '',
    chartAxisName: 'WindDirection Prevailing',
  },
  WindDirectionHigh: {
    columnName: 'wind_dir_of_hi',
    displayName: 'weatherDashboard.windDirectionHigh',
    metricUnit: '',
    imperialUnit: '',
    chartAxisName: 'Wind Direction High',
  },
  WindNumSamples: {
    columnName: 'wind_num_samples',
    displayName: 'weatherDashboard.windNumSamples',
    metricUnit: '',
    imperialUnit: '',
    chartAxisName: 'Wind Num Samples',
  },
  WindRun: {
    columnName: 'wind_run',
    displayName: 'weatherDashboard.windRun',
    metricUnit: 'km',
    imperialUnit: 'mi',
    chartAxisName: 'Wind Run',
  },
  AbsolutePressure: {
    columnName: 'abs_press',
    displayName: 'weatherDashboard.absolutePressure',
    metricUnit: 'hPa',
    imperialUnit: '',
    chartAxisName: 'Absolute Pressure',
  },
  BarometricPressure: {
    columnName: 'bar',
    displayName: 'weatherDashboard.barometricPressure',
    metricUnit: 'hPa',
    imperialUnit: '',
    chartAxisName: 'Barometric Pressure',
  },
  BarometricPressureAltitude: {
    columnName: 'bar_alt',
    displayName: 'weatherDashboard.barometricPressureAltitude',
    metricUnit: 'hPa',
    imperialUnit: '',
    chartAxisName: 'Barometric Pressure Altitude',
  },
  ArchInt: {
    columnName: 'arch_int',
    displayName: 'weatherDashboard.archInt',
    metricUnit: '',
    imperialUnit: '',
    chartAxisName: 'Arch Int',
  },
  AirDensity: {
    columnName: 'air_density',
    displayName: 'weatherDashboard.airDensity',
    metricUnit: 'kg/m³',
    imperialUnit: '',
    chartAxisName: 'AirDensity',
  },
  Evapotranspiration: {
    columnName: 'et',
    displayName: 'weatherDashboard.evapotranspiration',
    metricUnit: 'mm',
    imperialUnit: 'in',
    chartAxisName: 'Evapotranspiration',
    chartType: 'barChart',
    isFixed: 4,
  },
  EMC: {
    columnName: 'emc',
    displayName: 'weatherDashboard.emc',
    metricUnit: '%',
    imperialUnit: '%',
    chartAxisName: 'EMC',
  },
  ISSReception: {
    columnName: 'iss_reception',
    displayName: 'weatherDashboard.issReception',
    metricUnit: '%',
    imperialUnit: '%',
    chartAxisName: 'ISSReception',
  },
  NightCloudCover: {
    columnName: 'night_cloud_cover',
    displayName: 'weatherDashboard.nightCloudCover',
    metricUnit: '%',
    imperialUnit: '%',
    chartAxisName: 'Night Cloud Cover',
  },
  DegreeDaysCool: {
    columnName: 'deg_days_cool',
    displayName: 'weatherDashboard.degreeDaysCool',
    metricUnit: '',
    imperialUnit: '',
    chartAxisName: 'Degree Days Cool',
  },
  DegreeDaysHeat: {
    columnName: 'deg_days_heat',
    displayName: 'weatherDashboard.degreeDaysHeat',
    metricUnit: '',
    imperialUnit: '',
    chartAxisName: 'Degree Days Heat',
  },
  TimezoneOffset: {
    columnName: 'tz_offset',
    displayName: 'weatherDashboard.timezoneOffset',
    metricUnit: '',
    imperialUnit: '',
    chartAxisName: 'Timezone Offset',
  },
  RevType: {
    columnName: 'rev_type',
    displayName: 'weatherDashboard.revType',
    metricUnit: '',
    imperialUnit: '',
    chartAxisName: 'Rev Type',
  },
  PressureLastReading: {
    columnName: 'pressure_last',
    displayName: 'weatherDashboard.pressureLastReading',
    metricUnit: 'hPa',
    imperialUnit: '',
    chartAxisName: 'Pressure Last Reading',
  },
  WindChild: {
    columnName: 'wind_child',
    displayName: 'weatherDashboard.windChild',
    metricUnit: '',
    imperialUnit: '',
    chartAxisName: 'Wind Child',
  },
  VaporPressure: {
    columnName: 'vapor_pressure',
    displayName: 'Vapor Pressure',
    metricUnit: 'kPa',
    imperialUnit: '',
    chartAxisName: 'Vapor Pressure',
  },
  LightningStrikeCount: {
    columnName: 'lightning_strikes',
    displayName: 'Lightning Strike Count',
    metricUnit: '',
    imperialUnit: '',
    chartAxisName: 'Lightning Strike Count',
    chartType: 'barChart',
  },

  Flowrate: {
    columnName: 'Flowrate',
    displayName: 'Flowrate',
    metricUnit: '',
    imperialUnit: '',
    chartAxisName: 'Flowrate',
  },
  Pressure: {
    columnName: 'Pressure',
    displayName: 'Pressure',
    metricUnit: '',
    imperialUnit: '',
    chartAxisName: 'Pressure',
  },
  RWM145001: {
    columnName: 'RWM145001',
    displayName: 'RWM145001',
    metricUnit: '',
    imperialUnit: '',
    chartAxisName: '',
  },
  Usage: {
    columnName: 'Usage',
    displayName: 'Usage',
    metricUnit: '',
    imperialUnit: '',
    chartAxisName: '',
  },
  Downstream: {
    columnName: 'Downstream',
    displayName: 'Downstream',
    metricUnit: '',
    imperialUnit: '',
    chartAxisName: '',
  },
  RWM145050: {
    columnName: 'RWM145050',
    displayName: 'RWM145050',
    metricUnit: '',
    imperialUnit: '',
    chartAxisName: '',
  },
  Upstream: {
    columnName: 'Upstream',
    displayName: 'Upstream',
    metricUnit: '',
    imperialUnit: '',
    chartAxisName: 'Upstream',
  },
  Dielectricity: {
    columnName: 'dielectricity',
    displayName: 'Dielectricity',
    metricUnit: '',
    imperialUnit: '',
    chartAxisName: 'Dielectricity',
  },
  Conductivity: {
    columnName: 'conductivity',
    displayName: 'Conductivity',
    metricUnit: '',
    imperialUnit: '',
    chartAxisName: 'Conductivity',
  },
  WaterBalance: {
    columnName: 'water_balance',
    displayName: 'Water Balance',
    metricUnit: '',
    imperialUnit: '',
    chartAxisName: 'Water Balance',
  },
  FieldCapacity: {
    columnName: 'field_capacity',
    displayName: 'Field Capacity',
    metricUnit: '',
    imperialUnit: '',
    chartAxisName: '',
  },
  Salinity: {
    columnName: 'salinity',
    displayName: 'Salinity',
    metricUnit: '',
    imperialUnit: '',
    chartAxisName: 'Salinity',
  },
  Temperature: {
    columnName: 'temperature',
    displayName: 'Temperature',
    metricUnit: 'C',
    imperialUnit: 'F',
    chartAxisName: 'Temperature',
  },
  Moisture: {
    columnName: 'moisture',
    displayName: 'Moisture',
    metricUnit: '%',
    imperialUnit: '%',
    chartAxisName: 'Moisture',
  },
  Soil_moisture: {
    columnName: 'Soil_moisture',
    displayName: 'Soil Moisture',
    metricUnit: '%',
    imperialUnit: '%',
    chartAxisName: 'Soil Moisture',
  },
  ApplicationID: {
    columnName: 'applicationID',
    displayName: 'ApplicationID',
    metricUnit: '',
    imperialUnit: '',
    chartAxisName: 'ApplicationID',
  },
  Battery: {
    columnName: 'battery',
    displayName: 'Battery',
    metricUnit: '%',
    imperialUnit: '%',
    chartAxisName: 'Battery',
  },
  PAR: {
    columnName: 'par',
    displayName: 'PAR',
    metricUnit: '',
    imperialUnit: '',
    chartAxisName: 'PAR',
  },
  RSSI: {
    columnName: 'rssi',
    displayName: 'RSSI',
    metricUnit: '',
    imperialUnit: '',
    chartAxisName: 'RSSI',
  },
  BB_Flowrate: {
    columnName: 'BB_Flowrate',
    displayName: 'BB_Flowrate',
    metricUnit: '',
    imperialUnit: '',
    chartAxisName: '',
  },
  RWM910001: {
    columnName: 'RWM910001',
    displayName: 'RWM910001',
    metricUnit: '',
    imperialUnit: '',
    chartAxisName: '',
  },
  BB_Pressure: {
    columnName: 'BB_Pressure',
    displayName: 'BB Pressure',
    metricUnit: '',
    imperialUnit: '',
    chartAxisName: '',
  },
  Tank_Volume: {
    columnName: 'Tank_Volume',
    displayName: 'Tank Volume',
    metricUnit: '',
    imperialUnit: '',
    chartAxisName: '',
  },

  Tank_Level: {
    columnName: 'Tank_Level',
    displayName: 'Tank Level',
    metricUnit: '',
    imperialUnit: '',
    chartAxisName: 'Tank Level',
  },

  Supply1_Usage: {
    columnName: 'Supply1_Usage',
    displayName: 'Supply1 Usage',
    metricUnit: '',
    imperialUnit: '',
    chartAxisName: '',
  },
  Supply2_Usage: {
    columnName: 'Supply2_Usage',
    displayName: 'Supply2 Usage',
    metricUnit: '',
    imperialUnit: '',
    chartAxisName: 'Supply2 Usage',
  },
  Oval_Usage: {
    columnName: 'Oval_Usage',
    displayName: 'Oval Usage',
    metricUnit: '',
    imperialUnit: '',
    chartAxisName: 'Oval Usage',
  },
  Reading: {
    columnName: 'reading',
    displayName: 'Reading',
    metricUnit: '',
    imperialUnit: '',
    chartAxisName: 'Reading',
  },
  Flow: {
    columnName: 'flow',
    displayName: 'Flow',
    metricUnit: '',
    imperialUnit: '',
    chartAxisName: 'Flow',
  },
  Humidity: {
    columnName: 'humidity',
    displayName: 'Humidity',
    metricUnit: '%',
    imperialUnit: '%',
    chartAxisName: 'Humidity',
  },
  pressure: {
    columnName: 'pressure',
    displayName: 'Pressure',
    metricUnit: 'hPa',
    imperialUnit: 'inHg',
    chartAxisName: 'Pressure',
  },
}

export function getColumnDetails(columnName: string) {
  for (const key in WeatherReportFields) {
    const columnDetail =
      WeatherReportFields[key as keyof typeof WeatherReportFields]
    if (columnDetail.columnName.toLowerCase() === columnName.toLowerCase()) {
      return columnDetail
    }
  }
  return {
    columnName,
    displayName: columnName,
    metricUnit: '',
    imperialUnit: '',
    chartAxisName: columnName,
  }
}

export const AllWeatherReportFields = [
  WeatherReportFields.AbsolutePressure.columnName,
  WeatherReportFields.AirDensity.columnName,
  WeatherReportFields.ArchInt.columnName,
  WeatherReportFields.BarometricPressure.columnName,
  WeatherReportFields.BarometricPressureAltitude.columnName,
  WeatherReportFields.DegreeDaysCool.columnName,
  WeatherReportFields.DegreeDaysHeat.columnName,

  WeatherReportFields.DewPoint.columnName,
  WeatherReportFields.EMC.columnName,
  WeatherReportFields.Evapotranspiration.columnName,
  WeatherReportFields.HeatIndex.columnName,
  WeatherReportFields.HumidityOutdoor.columnName,

  WeatherReportFields.ISSReception.columnName,
  WeatherReportFields.NightCloudCover.columnName,
  WeatherReportFields.RainRateHighClicks.columnName,
  WeatherReportFields.RainRateHighIn.columnName,
  WeatherReportFields.RainRateHighMM.columnName,
  WeatherReportFields.RainFallClicks.columnName,
  WeatherReportFields.RainFallIn.columnName,
  WeatherReportFields.RainFall.columnName,

  WeatherReportFields.RevType.columnName,
  WeatherReportFields.SolarEnergy.columnName,
  WeatherReportFields.SolarRadiationAverage.columnName,
  WeatherReportFields.SolarRadiationHigh.columnName,

  WeatherReportFields.TemperatureOutdoor.columnName,
  WeatherReportFields.TemperatureOutdoorHigh.columnName,
  WeatherReportFields.TemperatureOutdoorLow.columnName,

  WeatherReportFields.THSWIndex.columnName,
  WeatherReportFields.THWIndex.columnName,
  WeatherReportFields.TimezoneOffset.columnName,
  WeatherReportFields.WetBulb.columnName,
  WeatherReportFields.WindChill.columnName,

  WeatherReportFields.WindDirectionHigh.columnName,
  WeatherReportFields.WindDirectionPrevailing.columnName,
  WeatherReportFields.WindNumSamples.columnName,
  WeatherReportFields.WindRun.columnName,
  WeatherReportFields.WindSpeedAverage.columnName,
  WeatherReportFields.WindSpeedHigh.columnName,
  WeatherReportFields.WindChill.columnName,
  WeatherReportFields.PressureLastReading.columnName,
  WeatherReportFields.Flow.columnName,
  // WeatherReportFields.Pressure.columnName,
  // WeatherReportFields.Humidity.columnName,
]

export const initialState: WeatherDashboardState = {
  latestWeatherReport: {},
  data24h: {},
  data30d: {},

  rainData: {},
  windDirectionData: {},
  barometerData: {},
  totalRainData: {},
  assetData: [],
  assetId: null,
  tagKeys: {},
  sensorTypes: { isLoading: false, data: [] },

  isLoadingLatestWeatherReport: false,
  isLoading24hTemperature: false,
  isLoadingRain: false,
  isLoadingWindDirection: false,
  isLoadingBarometer: false,
  isLoadingAssetData: false,
  isLoadingTotalRain: false,
  isLoadingTagKeys: false,
}

export interface WeatherDashboardState {
  latestWeatherReport: Record<string, WeatherReportData>
  data24h: Record<string, WeatherReportData[]>
  data30d: Record<string, WeatherReportData[]>

  rainData: Record<string, WeatherRainData[]>
  windDirectionData: Record<string, WeatherWindDirectionData>
  barometerData: Record<string, WeatherBarometerData[]>
  totalRainData: Record<string, WeatherRainData[]>
  assetData: AssetData[]
  assetId: number | null
  tagKeys: Record<string, string[]>
  sensorTypes: {
    isLoading: boolean
    data: SensorTypes[]
  }

  isLoadingLatestWeatherReport: boolean
  isLoading24hTemperature: boolean
  isLoadingRain: boolean
  isLoadingWindDirection: boolean
  isLoadingBarometer: boolean
  isLoadingAssetData: boolean
  isLoadingTotalRain: boolean
  isLoadingTagKeys: boolean
}

export interface WeatherReportData {
  timeSpan: string
  wind_speed_hi: number
  wind_speed_avg: number
  rainfall_mm: number
  strike_distance: number | null
  temp_out: number
  temp_out_hi: number
  temp_out_lo: number
  hum_out: number
  heat_index_out: number
  wind_chill: number
  dew_point_out: number
  wet_bulb: number
  thsw_index: number
  thw_index: number
  solar_rad_avg: number
  solar_rad_hi: number
  solar_energy: number
  rain_rate_hi_mm: number
  rain_rate_hi_in: number
  rain_rate_hi_clicks: number
  rainfall_clicks: number
  rainfall_in: number
  wind_dir_of_prevail: number
  wind_dir_of_hi: number
  wind_num_samples: number
  wind_run: number
  abs_press: number
  bar: number
  bar_alt: number
  arch_int: number
  air_density: number
  emc: number
  iss_reception: number
  night_cloud_cover: number
  deg_days_cool: number
  deg_days_heat: number
  tz_offset: number
  rev_type: number
  pressure_last: number
  Flowrate: number
  Pressure: number
  RWM145001: number
  lightning_strikes: number
}

export interface WeatherRainData {
  customName: string
  fieldName: string
  value: number
  color: string
}

export interface WeatherWindDirectionData {
  direction: string
  high: number
  value: number
}

export interface WeatherBarometerData {
  time: string
  timeSpan: string
  value: number
}

export interface AssetData {
  id: number
  deviceName: string
  topicName: string
  sensorTypeId?: number | null
  telemetryAssetId: number
  metadata?: {
    type: string
    imperial?: string
    metric?: string
    barChart?: boolean
    stepChart?: boolean
    chartType?: string
  }
}

export interface TimeRangeConfig {
  customName: string
  fieldName: '1h' | '24h' | '7days' | '30days'
  value?: number
  color: string
}

export interface FieldConfig {
  customName: string
  fieldName: '1h' | '24h' | '7days' | '30days'
  value?: number
  color: string
}

export interface FieldNameConfig {
  customName: string
  fieldName: string
  value?: number
  color: string
  columnName: string
}

export const rainConfigs: TimeRangeConfig[] = [
  { customName: '1 Hour', fieldName: '1h', color: '#5470C6' },
  { customName: '24 Hours', fieldName: '24h', color: '#5470C6' },
  { customName: '7 Days', fieldName: '7days', color: '#5470C6' },
]
export const ETConfigs: TimeRangeConfig[] = [
  { customName: '7 Days', fieldName: '7days', color: '#5470C6' },
  { customName: '30 Days', fieldName: '30days', color: '#5470C6' },
]

export const CurrentRainConfigs: TimeRangeConfig[] = [
  { customName: 'Days', fieldName: '24h', color: '#5470C6' },
  { customName: 'Storm', fieldName: '24h', color: '#5470C6' },
]

export const strikeCountConfigs: TimeRangeConfig[] = [
  { customName: '1 Hour', fieldName: '1h', color: '#5470C6' },
  { customName: '24 Hours', fieldName: '24h', color: '#5470C6' },
  { customName: '7 Days', fieldName: '7days', color: '#5470C6' },
]

export const TempConfigs: FieldNameConfig[] = [
  {
    customName: 'Outside temp',
    fieldName: 'Outside temp',
    color: '#FFBF00',
    columnName: WeatherReportFields.TemperatureOutdoor.columnName,
  },
  {
    customName: 'Wind chill',
    fieldName: 'Wind chill',
    color: '#FFBF00',
    columnName: WeatherReportFields.WindChill.columnName,
  },
  {
    customName: 'Heat Index',
    fieldName: 'Heat Index',
    color: '#FFBF00',
    columnName: WeatherReportFields.HeatIndex.columnName,
  },
  {
    customName: 'Dew Point',
    fieldName: 'Dew Point',
    color: '#FFBF00',
    columnName: WeatherReportFields.DewPoint.columnName,
  },
  {
    customName: 'Web Bulb',
    fieldName: 'Web Bulb',
    color: '#FFBF00',
    columnName: WeatherReportFields.WetBulb.columnName,
  },
]

export const WIND_DIRECTIONS = [
  'N',
  'NNE',
  'NE',
  'ENE',
  'E',
  'ESE',
  'SE',
  'SSE',
  'S',
  'SSW',
  'SW',
  'WSW',
  'W',
  'WNW',
  'NW',
  'NNW',
]

export const FIFTEEN_MINUTES = 15 * 60 * 1000
